
export class Habilitation {
    userId: string;
    _id:string;
    id:string;
    intitule:string;
    created:Date;
    updated: Date;
  }
